import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["btn", "panel"]

  toggle() {
    this.panelTarget.classList.toggle("hidden")
    const isVisible = !this.panelTarget.classList.contains("hidden")
    this.btnTarget.textContent = isVisible ? "Ocultar consumo" : "Ver consumo"
  }
}
